import { Route, Routes,BrowserRouter } from "react-router-dom";
import Acceuil from "./Page/Acceuil"
import Menu from "./Page/Menu"
import QR from "./Page/qrcode"


function App() {
  return (
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Acceuil />}  />
        <Route path="/menu" element={<Menu />}  /> 
        {/* <Route path="/qr" element={<QR />}  />  */}
        

      </Routes>
      </BrowserRouter>
  );
}

export default App;
